import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { IdentityService } from '../../core/identity.service';
import { UserService } from '../../core/user.service';

/**
 * Permite el acceso con un token vigente de obra-backend. Si venció, intenta
 * renovarlo con la sesión Firebase y la última empresa; si no, envía a /login.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    private userService: UserService,
    private identityService: IdentityService) { }

  async canActivate(): Promise<boolean | UrlTree> {
    const storedToken = this.userService.storedToken();
    if (storedToken) {
      this.userService.setTokenSubject(storedToken);
      return true;
    }

    const user = await this.identityService.currentUser().catch(() => null);
    const company = localStorage.getItem('companyName');
    if (user && company && this.userService.getAuthUserData()) {
      const result = await firstValueFrom(this.userService.exchangeFirebaseToken());
      if (result.token) return true;
    }

    return this.router.createUrlTree(['/login']);
  }
}
